// PieChart.js
import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

export default function Piechart() {
  const data = {
    labels: ["Cash", "UPI", "Transfer"],
    datasets: [
      {
        data: [24, 56, 40],   // values
        backgroundColor: [
          "#FF6384", // Red
          "#36A2EB", // Blue
          "#FFCE56", // Yellow
          "#4BC0C0"  // Green
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom", // top | left | right | bottom
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div style={{ width: "400px", margin: "auto" }}>
      <h3 className="text-center font-bold mb-2" style={{color:"black"}}>My Pie Chart</h3>
      <Pie data={data} options={options} />
    </div>
  );
}
